import useDeviceSize, { LG_BREAKPOINT } from '../hooks/useDeviceSize';
import useEbcSolarStore from '../store/ebc-solar-store';

type QuotationNavbarProps = {
    price: number;
};

const QuotationNavbar = ({ price }: QuotationNavbarProps) => {
    const { width, height, isMobile } = useDeviceSize();

    const setCtaSqueezePopupModalOpen = useEbcSolarStore((state) => state.setCtaSqueezePopupModalOpen);

    const handleClick = () => {
        setCtaSqueezePopupModalOpen(true);
    };

    return (
        <div
            style={{
                width: '100%',
                height: 'auto',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                margin: 0,
                padding: 0,
                paddingTop: '1rem',
                paddingBottom: '1rem',
                background: '#212121',
                zIndex: 999,

                position: 'sticky',
                top: 0,
            }}
        >
            <div
                style={{
                    width: '100%',
                    maxWidth: width < LG_BREAKPOINT ? '80%' : '1280px',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.5rem',
                    }}
                >
                    <span style={{ fontSize: isMobile ? '14px' : '16px', fontWeight: 500, color: '#FFFFFF' }}>Price</span>
                    <span style={{ fontSize: isMobile ? '20px' : '24px', fontWeight: 600, color: '#FFFFFF' }}>£{price.toLocaleString()}</span>
                </div>

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        paddingLeft: isMobile ? '1rem' : '4rem',
                        paddingRight: isMobile ? '1rem' : '4rem',
                        paddingTop: '1rem',
                        paddingBottom: '1rem',
                        borderRadius: '16px',
                        color: '#FFFFFF',
                        fontSize: isMobile ? '14px' : '16px',
                        fontWeight: 600,
                        background: '#26A757',
                        cursor: 'pointer',
                    }}
                    onClick={handleClick}
                >
                    Confirm Your Price
                </div>
            </div>
        </div>
    );
};

export default QuotationNavbar;
